import { Skeleton, Stack } from '@mui/material';

import styles from './InputFieldSkeletonLoader.module.scss';

export const InputFieldSkeletonLoader = () => {
  return (
    <Stack className={styles.InputFieldSkeletonLoader} gap={1.5}>
      <Skeleton variant="rounded" width={80} height={12} />
      <Skeleton variant="rounded" width="100%" height={34} />
    </Stack>
  );
};
